import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";

import {getFeatureFromUrl} from "../shopPagesFunctions";
// import ShopFeatureContext, {shopFeatureContextAction, shopFeatureContextReducer} from "./shopFeatureContext";
import ShopFeature from "./shopFeature";
import WithUpdateLookCartItem from "../../hocs/withUpdateLookCartItem";
import {useShopContext} from "../shopCategory/shopNavItemsContext";
import MaterialSpinner from "../../../ui/materialSpinner";
import {getBvFeatures} from "../../../../api/server-api";
import {getCurrentLayout} from "../../../appLayout";
import {setAllowMainLoading} from "../../../../actions/serverFunctions";


const ShopFeaturePage = (props) => {

  const {setAllowMainLoading, allowMainLoading} = props;

  const {shopContextState} = useShopContext();
  const {shopFeatureGroup, shopActiveFeature} = shopContextState;
  const [feature, setFeature] = useState(null);
  const [featureDownloaded, setFeatureDownloaded] = useState(false);

  const getFeature = async () => {
    if (!shopActiveFeature) {
      return
    }
    let featureFromUrl = getFeatureFromUrl(shopFeatureGroup, shopActiveFeature);
    if (!featureFromUrl) {
      const response = await getBvFeatures(null, [shopActiveFeature]);
      if (response && response.data) {
        const layout = getCurrentLayout();
        layout.loadNewFeatures(response.data);
        featureFromUrl = getFeatureFromUrl(shopFeatureGroup, shopActiveFeature);
        if (!featureFromUrl) {
          const newResponse = await getBvFeatures(null, [shopActiveFeature], true);
          if (newResponse && newResponse.data) {
            layout.loadNewFeatures(newResponse.data);
            featureFromUrl = getFeatureFromUrl(shopFeatureGroup, shopActiveFeature, true);
          }
        }
      }
    }
    setFeatureDownloaded(true);
    if (featureFromUrl) {
      setFeature(featureFromUrl)
    }
  }

  useEffect(() => {
    if (!allowMainLoading) {
      setAllowMainLoading(true); // here we request all data to show View in Visualizer without the loading
    }
    getFeature();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopActiveFeature, shopFeatureGroup])

  if (!shopActiveFeature) {
    return null
  }

  // if (!shopFeatureContextState.feature) {
  if (!feature) {
    if (!featureDownloaded) {
      return <MaterialSpinner withCounter={true}/>
    }
    return <h3>Feature not found. Please check opened URL</h3>
  }

  // return (
  //   <ShopFeatureContext.Provider value={{shopFeatureContextState, shopFeatureContextDispatch}} >
  //     <ShopFeature/>
  //   </ShopFeatureContext.Provider>
  // )

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem) => <ShopFeature feature={feature} updateLookCartItem={updateLookCartItem}/>}
    </WithUpdateLookCartItem>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded, allowMainLoading} = store.serverState;

  return {
    visualizersLoadedLength: visualizersLoaded.length,
    allowMainLoading,
  };
};

const mapDispatchToProps = {
  setAllowMainLoading,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShopFeaturePage)
)
